import React, { Component } from 'react';
import { Guardian } from '@xaamin/guardian';
import { Container } from 'react-bootstrap';

import './Sidebar.css';

import Pacs from '../admin/pacs/Pacs';
import { Event } from '../support';
import PacsInfo from '../admin/pacs/PacsInfo';
import Clientes from '../admin/clientes/Clientes';
import PacsUpsert from '../admin/pacs/PacsUpsert';
import AdminSidebar from './sidebar/AdminSidebar';
import GuardianRoute from '../shared/GuardianRoute';
import PageError403 from '../shared/errors/PageError403';
import ClientesEdit from '../admin/clientes/ClientesEdit';
import ClientesInfo from '../admin/clientes/ClientesInfo';
import HttpErrorMonitor from '../support/HttpErrorMonitor';
import ClientesInvite from '../admin/clientes/ClientesInvite';
import NavBarHeader from './components/navbar-header/NavBarHeader';
import DashboardClientes from '../admin/dashboard/DashboardClientes';
import DashboardClientesInfo from '../admin/dashboard/DashboardClientesInfo';
import ReporteNuevosClientes from '../admin/reportes/clientes/ReporteNuevosClientes';
import SessionOverrideHighlighter from '../shared/session/SessionOverrideHighlighter';
import AdminReportesPacsBalance from '../admin/reportes/pacs/AdminReportesPacsBalance';
import ReporteNuevoClienteInfo from '../admin/reportes/clientes/ReporteNuevoClienteInfo';
import EmisoresSoonToExpireHighlighter from '../app/emisores/EmisoresSoonToExpireHighlighter';
import ReporteFacturacionStorage from '../admin/reportes/facturacion/ReporteFacturacionStorage';
import ReporteFacturacionDetalle from '../admin/reportes/facturacion/ReporteFacturacionDetalle';
import ReporteFacturacionClientes from '../admin/reportes/facturacion/ReporteFacturacionClientes';
import ReporteFacturacionHitsPorPac from '../admin/reportes/facturacion/ReporteFacturacionHitsPorPac';
import AccountSuspendedHighlighter from '../admin/clientes/list/components/AccountSuspendedHighlighter';

class AdminLayout extends Component {
  notification = null;

  state = {
    open: false,
  };

  _mounted = false;

  constructor(props) {
    super(props);

    Event.on('drawer.close', this.handleDrawerNeedsClose);
  }

  componentWillUnmount() {
    Event.on('drawer.close', this.handleDrawerNeedsClose);
  }

  handleDrawerNeedsClose = () => {
    this.setState({
      open: false,
    });
  };

  handleOnToggleSidebar = (state = null) => {
    state = state !== null ? state : !this.state.open;

    this.setState({
      open: state,
    });
  };

  render() {
    const { open } = this.state;

    const sidebarClassName = !!open ? 'sidebar-open' : '';

    if (!Guardian.allows('root.access')) {
      return <PageError403 />;
    }

    return (
      <Container
        fluid
        className={`app-wrapper ${sidebarClassName}`}
      >
        <NavBarHeader
          fluid={false}
          onToggleSidebar={this.handleOnToggleSidebar}
        />

        <HttpErrorMonitor />

        <AccountSuspendedHighlighter />

        <EmisoresSoonToExpireHighlighter />

        <SessionOverrideHighlighter />

        <div
          className="sidebar-backdrop"
          onClick={this.handleOnToggleSidebar.bind(this, false)}
        ></div>

        <div className="d-block d-lg-none d-xl-none">
          <AdminSidebar
            open={open}
            onMenuItemClick={this.handleOnToggleSidebar.bind(this, false)}
          />
        </div>

        <div className="app-container container">
          <div className="d-none d-lg-flex d-xl-flex">
            <AdminSidebar onMenuItemClick={this.handleOnToggleSidebar.bind(this, false)} />
          </div>

          <div className="main-container">
            <div className="page-container">
              <GuardianRoute
                path="/admin/dashboard"
                component={DashboardClientes}
                can="admin.dashboard.clientes.listar"
                exact
              />
              <GuardianRoute
                path="/admin/dashboard/:id/info"
                component={DashboardClientesInfo}
                can="admin.dashboard.clientes.info"
                exact
              />

              <GuardianRoute
                path="/admin/clientes"
                component={Clientes}
                can="cliente.listar"
                exact
              />
              <GuardianRoute
                path="/admin/clientes/registrar"
                component={ClientesInvite}
                can="cliente.crear"
                exact
              />
              <GuardianRoute
                path="/admin/clientes/:id/info"
                component={ClientesInfo}
                can="cliente.info"
                exact
              />
              <GuardianRoute
                path="/admin/clientes/:id/editar"
                component={ClientesEdit}
                can="cliente.editar"
                exact
              />

              <GuardianRoute
                path="/admin/pacs"
                component={Pacs}
                can="pac.listar"
                exact
              />
              <GuardianRoute
                path="/admin/pacs/registrar"
                component={PacsUpsert}
                can="pac.crear"
                exact
              />
              <GuardianRoute
                path="/admin/pacs/:id/info"
                component={PacsInfo}
                can="pac.info"
                exact
              />
              <GuardianRoute
                path="/admin/pacs/:id/editar"
                component={PacsUpsert}
                can="pac.editar"
                exact
              />

              <GuardianRoute
                path="/admin/reportes/facturacion"
                component={ReporteFacturacionClientes}
                can="reporte.facturacion.listar"
                exact
              />
              <GuardianRoute
                path="/admin/reportes/facturacion/:id/detalle"
                component={ReporteFacturacionDetalle}
                can="reporte.facturacion.listar"
                exact
              />

              <GuardianRoute
                path="/admin/reportes/hits-por-pac"
                component={ReporteFacturacionHitsPorPac}
                can="reporte.hits.por.pac.listar"
                exact
              />
              <GuardianRoute
                path="/admin/reportes/storage"
                component={ReporteFacturacionStorage}
                can="reporte.hits.por.pac.listar"
                exact
              />
              <GuardianRoute
                path="/admin/reportes/pac-balance"
                component={AdminReportesPacsBalance}
                can="pac.listar"
                exact
              />

              <GuardianRoute
                path="/admin/reportes/clientes"
                component={ReporteNuevosClientes}
                can="reporte.nuevos.clientes.listar"
                exact
              />
              <GuardianRoute
                path="/admin/reportes/clientes/:id/info"
                component={ReporteNuevoClienteInfo}
                can="reporte.nuevos.clientes.listar"
                exact
              />
            </div>
          </div>
        </div>
      </Container>
    );
  }
}

export default AdminLayout;
